<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

    <app-dashboard-navbar></app-dashboard-navbar>
    <div class="spinner-overlay" *ngIf="isLoading">
        <div class="spinner"></div>
      </div>

    <!-- Breadcrumb Area -->
    <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item"><a routerLink="/">Home</a></li>
            <li class="item"><a routerLink="dashboard">{{Content.subTitle}}</a></li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <!-- End Breadcrumb Area -->

    <!-- Start -->
    <div class="add-listings-box">
        <h3>Basic Informations</h3>
    
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <label><i class='bx bx-briefcase-alt'></i> Business Name:
                    <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Name of your business" 
                    [(ngModel)]="businessDetail.BUSINESS_NAME" name="BUSINESS_NAME" maxlength="40"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-envelope"></i> Email
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="email" class="form-control" placeholder="Enter your email"
                    [(ngModel)]="businessDetail.EMAIL_ADDRESS" name="EMAIL_ADDRESS" maxlength="40"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-pass"></i> Password</label>
                    <div class="input-group">
                        <input [type]="showPassword ? 'text' : 'password'" class="form-control" placeholder="Enter your password"
                            maxlength="20" [(ngModel)]="businessDetail.PASSWORD" name="PASSWORD">
                        <span class="input-group-text">
                            <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'" (click)="togglePasswordVisibility()"></i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-pass"></i> Verify Password</label>
                    <div class="input-group">
                        <input [type]="showVerifyPassword ? 'text' : 'password'" class="form-control" placeholder="Enter your password"
                            [(ngModel)]="businessDetail.VERIFY_PASSWORD" name="VERIFY_PASSWORD">
                        <span class="input-group-text">
                            <i class="bi" [ngClass]="showVerifyPassword ? 'bi-eye-slash' : 'bi-eye'" (click)="toggleVerifyPasswordVisibility()"></i>
                        </span>
                    </div>
                    <small *ngIf="passwordMismatch" style="color:red;">Passwords do not match</small>
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-calendar2-event"></i> Hours</label>
                    <input type="number" class="form-control" placeholder="Enter your email"
                    [(ngModel)]="businessDetail.BUSINESS_HOURS" name="BUSINESS_HOURS"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-menu-alt-left'></i> Address
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="e.g. 55 County Laois"
                    [(ngModel)]="businessDetail.BUSINESS_ADDRESS" name="BUSINESS_ADDRESS" maxlength="50"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-bricks"></i> City
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Enter your city"
                    [(ngModel)]="businessDetail.BUSINESS_CITY" name="BUSINESS_CITY" maxlength="20"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-bricks"></i> Zip Code
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Enter your city"
                    [(ngModel)]="businessDetail.ZIP_CODE" name="ZIP_CODE" maxlength="10"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-bricks"></i> State
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Enter your city"
                    [(ngModel)]="businessDetail.STATE" name="STATE" maxlength="10"
                    >
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-menu-alt-left'></i> Google Location Link
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="e.g. 55 County Laois"
                    [(ngModel)]="businessDetail.BUSINESS_ADDRESS_LINK" name="BUSINESS_ADDRESS" maxlength="50"
                    >
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-phone-call'></i> Phone No
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Phone Number"
                    [(ngModel)]="businessDetail.CONTACT_NO" name="BUSINESS_ADDRESS" maxlength="10"
                    mask="(000) 000-0000"
                    >
                </div>
            </div>

            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-menu-alt-left'></i> Date & Time</label>
                    <input type="date" class="form-control" placeholder="e.g. 55 County Laois"
                    
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-duplicate'></i> Select Category
                        <span style="color: red;"> *</span>
                    </label>
                    <select [(ngModel)]="businessDetail.BUSINESS_CATEGORY" (ngModelChange)="onCategoryChange($event)">
                        <option value="" disabled selected>Choose a Category</option>
                        <option *ngFor="let category of categories" [value]="category.name">
                          {{ category.name }}
                        </option>
                      </select>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bx bx-duplicate'></i> Select Sub Category
                        <span style="color: red;"> *</span>
                    </label>
                   <!-- Subcategory Dropdown (Populated by tempList) -->
                 <select [(ngModel)]="businessDetail.BUSINESS_CATEGORY_TYPE">
                     <option value="" disabled selected>Choose an option</option>
                     <option *ngFor="let item of tempList">{{ item }}</option>
                   </select>
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-instagram instagram-icon"></i> Instagram
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Instagram Link"
                    [(ngModel)]="businessDetail.INSTAGRAM_LINK" name="BUSINESS_ADDRESS" maxlength="500"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group" style="padding-left: inherit;">
                  <label>
                    <!-- Image for the official X logo -->
                    <img src="assets/images/X_log.PNG" alt="Twitter Logo" class="x-logo" style="width: 24px; height: 24px; vertical-align: middle; border-radius: 50%;">
                    Twitter <span style="color: red;"> *</span>
                  </label>
                  <input type="text" class="form-control" placeholder="Twitter Link"
                    [(ngModel)]="businessDetail.TWITTER_LINK" name="TWITTER_LINK" maxlength="500">
                </div>
              </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class='bi bi-tiktok tiktok-icon'></i> Tiktok
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Tiktok Link"
                    [(ngModel)]="businessDetail.TIKTOK_LINK" name="TIKTOK_LINK" maxlength="500"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-facebook facebook-icon"></i> Facebook
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Facebook Link"
                    [(ngModel)]="businessDetail.FACEBOOK_LINK" name="FACEBOOK_LINK" maxlength="500"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-linkedin linkedin-icon"></i> Linkedin
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Linkedin Link"
                    [(ngModel)]="businessDetail.LINKEDIN_LINK" name="LINKEDIN_LINK" maxlength="500"
                    >
                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="form-group">
                    <label><i class="bi bi-youtube youtube-icon"></i> Youtube
                        <span style="color: red;"> *</span>
                    </label>
                    <input type="text" class="form-control" placeholder="Youtube Link"
                    [(ngModel)]="businessDetail.YOUTUBE_LINK" name="YOUTUBE_LINK" maxlength="500"
                    >
                </div>
            </div>

            
        </div>
    </div>

    <div class="add-listings-box">
        <h3>Business Logo</h3>
        <div>
            <div class="col-md-12">
                <ol id="ol-uploadimg-imgname">
                    <li *ngFor="let fileName of uploadedLogoFilesName; let ndx=index" [id]="'opt-uploadimg-imgname-'+ndx"><a [id]="'a-imgname-'+ndx" href="FoxDocumentDirectory\RequestForOrder\UploadImages\{{fileName}}"
                            target="_blank">{{fileName}}</a></li>
                </ol>
            </div>
            
            <div class="clearfix"></div>
            
            <dropzone id="p-uploadimg-dropzone" [config]="config" [message]="'Click or Drag Images and Documents here to upload (.pdf, .png, .jpg/.jpeg, .tif/.tiff, .bmp)'" (maxFilesExceeded)="onMaxFilesExceeded()"
    (maxFilesReached)="onMaxFilesReached()" (removedFile)="onRemoveFile($event)" (error)="onUploadError($event)"
    (success)="onUploadSuccess($event, true)" (canceled)="onCanceled($event)"></dropzone>
        </div>
    </div>

    <div class="add-listings-box">
        <h3>Opening Hours</h3>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Monday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.MONDAY_OPENING_TIME">
                    <option value="" disabled selected>Select closing time</option>
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.MONDAY_CLOSING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Tuesday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.TUESDAY_OPENING_TIME ">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.TUESDAY_CLOSING_TIME ">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Wednesday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.WEDNESDAY_OPENING_TIME ">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.WEDNESDAY_CLOSING_TIME ">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Thursday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.THURSDAY_OPENING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.THURSDAY_CLOSING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Friday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.FRIDAY_OPENING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.FRIDAY_CLOSING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Saturday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.SATURDAY_OPENING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.SATURDAY_CLOSING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>

        <div class="row opening-day align-items-center">
            <div class="col-lg-2 col-md-12">
                <h5>Sunday</h5>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.SUNDAY_OPENING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>

            <div class="col-lg-5 col-md-6">
                <select [(ngModel)]="this.businessDetail.SUNDAY_CLOSING_TIME">
                    <option *ngFor="let slot of timeSlots" [value]="slot">{{ slot }}</option>
                </select>
            </div>
        </div>
    </div>

    <div class="add-listings-box">
        <h3>Business Banner</h3>
        <div>
            <div class="col-md-12">
                <ol id="ol-uploadimg-imgname">
                    <li *ngFor="let fileName of uploadedFilesName; let ndx=index" [id]="'opt-uploadimg-imgname-'+ndx"><a [id]="'a-imgname-'+ndx" href="FoxDocumentDirectory\RequestForOrder\UploadImages\{{fileName}}"
                            target="_blank">{{fileName}}</a></li>
                </ol>
            </div>
            
            <div class="clearfix"></div>
            
            <dropzone id="p-uploadimg-dropzone" [config]="config" [message]="'Click or Drag Images and Documents here to upload (.pdf, .png, .jpg/.jpeg, .tif/.tiff, .bmp)'" (maxFilesExceeded)="onMaxFilesExceeded()"
    (maxFilesReached)="onMaxFilesReached()" (removedFile)="onRemoveFile($event)" (error)="onUploadError($event)"
    (success)="onUploadSuccess($event)" (canceled)="onCanceled($event)"></dropzone>
        </div>
    </div>

    <div class="add-listings-box">
        <h3>Details <span style="color: red;"> *</span></h3>
    
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="form-group">
                    <label><i class='bx bx-text'></i> Description:</label>
                    <textarea cols="30" rows="7" class="form-control" placeholder="Details..."
                    [(ngModel)]="businessDetail.BUSINESS_IMPORTANT_NOTES" name="BUSINESS_IMPORTANT_NOTES" maxlength="500"
                    ></textarea>
                </div>
            </div>
        </div>
    </div>   
    <div class="add-listings-btn">
        <button type="submit" (click)="addUpdateBusiness()">Submit Listings</button>
    </div>
    <!-- End -->

    <div class="flex-grow-1"></div>
    
    <!-- <app-copyrights></app-copyrights> -->

</div>
<!-- End Main Content Wrapper Area -->